export default __webpack_public_path__ + "static/media/cake-6.200c149f.jpg";